import { Attachment, FileItem, FileItemsMap, FileItemStatusEnum } from "types";
import { PersonDTO } from "serverApi/vehicleSubjectChange";

import { Subject } from "./types/VehicleSubjectChangeFormValues";

export const getIsAnyFileItemPending = (items: FileItem[]) => {
    if (!items) {
        return false;
    }

    const pendingFiles = items.filter((item: FileItem) => item.uploadStatus === FileItemStatusEnum.PENDING);
    return pendingFiles.length > 0;
};

export const getIsSuccessUploadStateInEveryFileItem = (items: FileItem[]) => {
    if (!items || !items.length) {
        return true;
    }

    const successStates = [FileItemStatusEnum.DATA_IN_FORM, FileItemStatusEnum.UPLOADED];

    const incorrectFileItems = items.filter((item: FileItem) => !successStates.includes(item.uploadStatus));
    return incorrectFileItems.length === 0;
};

export const isAllAttachmentsUploaded = (attachments: Attachment[], uploadedAttachments: FileItemsMap) => {
    // Check if all required attachment has at min one file uploaded.
    const missingAttachments = attachments
        ?.filter((attachment) => !attachment?.isOptional)
        ?.map((requiredAttachment) => uploadedAttachments[requiredAttachment.type]?.length > 0)
        ?.filter((item) => !item);

    // Check that no attachment is in other that UPLOADED state.
    const pendingAttachments = attachments
        ?.map((attachment) => getIsSuccessUploadStateInEveryFileItem(uploadedAttachments[attachment.type]))
        ?.filter((item) => !item);

    return missingAttachments?.length === 0 && pendingAttachments?.length === 0;
};

// TODO: Tmp - refactor form data structure.
type InputSignatureBlock = {
    signatureType: string;
    dateOfSigning: string;
    placeOfSigning: string;
};

type OutputSignature = {
    type: "ELECTRONIC" | "PHYSICAL";
    date: string;
    place: string;
    uploadedFiles?: any[];
};

export function transformSubject(input: PersonDTO): Subject {
    // @ts-ignore
    const isIndividual = input.subjectType === "Individual";

    return {
        legalEntity: isIndividual ? 1 : 2,
        person: isIndividual
            ? {
                  birthNumber: input.birthNumber,
                  firstName: input.firstName,
                  lastName: input.lastName,
                  phone: input.phoneNumber,
                  email: input.email,
              }
            : undefined,
        organisation: !isIndividual
            ? {
                  organisationId: input.companyIdentificationNumber,
                  name: input.companyName,
              }
            : undefined,
        address: {
            street: input.address.street,
            descriptiveNo: input.address.descriptionNumber,
            orientationNo: input.address.orientationNumber,
            city: input.address.city,
            zipCode: input.address.postalCode,
            country: input.address.countryCode,
        },
    };
}

export function transformSignature(input: InputSignatureBlock): OutputSignature {
    return {
        type: input.signatureType.toUpperCase() as "ELECTRONIC" | "PHYSICAL",
        date: new Date(input.dateOfSigning).toISOString(),
        place: input.placeOfSigning,
        uploadedFiles: [],
    };
}
